import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { SubmissionError } from 'redux-form'

import { getCurrentOrganizationId } from '../../../ducks/users'
import { inviteUser } from '../../../ducks/organization-users'
import Modal from '../../Shared/Modal'
import Form from './InviteForm'

export default function InviteUser({ match }) {
  const organizationId = useSelector(getCurrentOrganizationId)
  const history = useHistory()
  const dispatch = useDispatch()

  const handleClose = () => {
    history.push('/settings')
  }

  const handleSubmit = async values => {
    let { email, role } = values

    try {
      await dispatch(inviteUser(organizationId, email, role))

      handleClose()
    } catch (err) {
      console.error(err)

      let message =
        (err && err.response && err.response.data && err.response.data.error) ||
        'An unknown error occurred'

      throw new SubmissionError({
        _error: message,
      })
    }
  }

  const initialValues = {
    role: 'editor',
  }

  return (
    <Modal onClose={handleClose}>
      <Form onSubmit={handleSubmit} initialValues={initialValues} />
    </Modal>
  )
}
